const FrImageBox = {
    images: [],
    init(){
        FrImageBox.images = document.querySelectorAll('.fr-view img')
        if (FrImageBox.images != null) {
            Array.from(FrImageBox.images).forEach((item,index) => {
                item.classList.add('cursor-pointer');
                item.setAttribute('data-fancybox','frView');
            })
        }
    }
}

FrImageBox.init();
